import api from './interceptorServices';
import { base_url } from '../config'; 

const api_url = `${base_url}api/webinarQa`;

export const getData = async () => {
  try{
  const response = await api.get(api_url);
  return response.data.data;
  }
  catch (error) {
    console.error("Error fetching data:", error);
    throw error; // Rethrow the error to handle it in the calling function
  }
};

export const addData = async (data) => {
  try{
  const response = await api.post(api_url, data);
  return response.data;
  }
  catch (error) {
    console.error("Error adding data:", error);
    throw error; // Rethrow the error to handle it in the calling function
  }
};

export const updateData = async (data) => {
  try{
  const response = await api.put(api_url, data);
  return response.data;
  }
  catch (error) {
    console.error("Error updating data:", error);
    throw error; // Rethrow the error to handle it in the calling function
  }
};

export const deleteData = async (data) => {
  try{
  const response = await api.delete(api_url, {
    data: { id: data.id },
  });
  return response.data;
  }
  catch (error) {
    console.error("Error deleting data:", error);
    throw error; // Rethrow the error to handle it in the calling function
  }
};